<div class="g-0">
    <div class="col">
        <div class="box-wrapper box-documenteGenerate">
            <div class="box-content-header box-content-header-documenteGenerate">
                <div class="row p-1">
                    <div class="col">
                        <mat-card-title>
                            <i class="fa-regular fa-file"></i>
                            <span>Documente Generate/CF</span>
                        </mat-card-title>
                    </div>
                </div>
            </div>
            <div class="box-content-body">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="d-flex align-items-center justify-content-between p-2">
                                    <span>
                                        Documente Generate: <strong>{{ cerere.cfs?.docs_generate || 0 }}</strong>
                                    </span>
                                    <span>
                                        CF-uri active: <strong>{{ cerere.cfs?.active || 0 }}</strong>
                                    </span>
                                    <button *ngIf="!viewMatricole" type="button"
                                        class="btn btn-sm btn-info"
                                        (click)="getMatricole()" [disabled]="disableBtnMatricole">
                                        Vezi Matricole
                                    </button>
                                    <div *ngIf="viewMatricole" class="d-flex align-items-center">
                                        <button type="button" class="btn btn-sm btn-info me-2"
                                            (click)="rerenderDT()" [disabled]="disableBtnMatricole">
                                            Reîncarcă Matricole
                                        </button>
                                        <button type="button" class="btn btn-sm btn-warning"
                                            (click)="closeMatricole()" [disabled]="disableBtnMatricole">
                                            Închide Matricole
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="!viewMatricole" class="col-sm-12">
                        <div class="row">
                            <div class="col-sm-12">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>ID Intern</th>
                                            <th>Status Document</th>
                                            <th>Informații CF</th>
                                            <th>#</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let row of cerere.doc_generate">
                                            <td width="5%">#{{ row.id_document }}</td>
                                            <td width="15%">
                                                <p>
                                                    <i class="fa fa-user"></i> {{ row.created_user_name }}
                                                </p>
                                                <p>
                                                    <i class="fa fa-calendar"></i> {{ formatCreatedAt(row.created_at) }}
                                                </p>
                                                <p>
                                                    <span class="badge" [ngClass]="{'bg-red': row.status == 0, 'bg-green': row.status == 1}">
                                                        <span *ngIf="row.status === 1">Activ</span>
                                                        <span *ngIf="row.status === 0">Inactiv</span>
                                                    </span>
                                                </p>
                                                <hr/>
                                                <p *ngIf="row.cancel_date !== null">
                                                    <strong>CF Anulat: </strong>
                                                </p>
                                                <p *ngIf="row.cancel_date !== null">
                                                    <i class="fa fa-user"></i> 
                                                    {{ row.cancel_user_name }}
                                                </p>
                                                <p *ngIf="row.cancel_date !== null">
                                                    <i class="fa fa-calendar"></i>
                                                    {{ formatCreatedAt(row.cancel_date) }}
                                                </p>
                                                <p *ngIf="row.cancel_date !== null">
                                                    Motiv: {{ row.cancel_user_obs }}
                                                </p>
                                            </td>
                                            <td width="50%">
                                                <p><strong>Operație</strong> {{ row.operatie }} </p>
                                                <p><strong>Scop CF</strong> {{ row.scopcf }} </p>
                                                <p><strong>Fără Listă Patrimoniu</strong>  {{ row.fara_lista_patrimoniu }}</p>
                                                <p><strong>Specificații</strong> {{ row.specificatii || 'n/a' }}</p>
                                                <p><strong>Alte Mențiuni</strong> {{ row.alte_mentiuni || 'n/a'}}</p>
                                                <p><strong>Matricole selectate:</strong> {{ row.matricole_arr.length }} / {{ row.matricole_json.length }}</p>
                                            </td>
                                            <td width="30%">
                                                <div class="row gap-2">
                                                    <div class="col-xl">
                                                        <button type="button" class="btn btn-sm btn-info"
                                                            (click)="viewMatricoleCF(row)">
                                                            Vezi Matricole
                                                        </button>
                                                    </div>
                                                    <div class="col-xl">
                                                        <button type="button" class="btn btn-sm btn-primary"
                                                            *ngIf="row.cancel_date == null" (click)="downloadCF(row.id_document)">
                                                            Descarcă CF
                                                        </button>
                                                    </div>
                                                    <div class="col-xl">
                                                        <button type="button" class="btn btn-sm btn-danger"
                                                            *ngIf="row.cancel_date == null" (click)="cancelCF(row.id_document)">
                                                            Anulare CF
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="viewMatricole" class="col-sm-12 p-2">
                        <br />
                        <div class="table-container m-2">
                            <table id="datatable" class="row-border hover custom-dt w-100" datatable [dtOptions]="dtOptions"
                                [dtTrigger]="dtTrigger"></table>
                        </div>
                        <br />
                        <hr />
                    </div>

                    <div *ngIf="viewMatricole && checkboxSelections" class="col-sm-12">
                        <table class="table">
                            <tfoot>
                                <tr>
                                    <td colspan="5">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <h4>
                                                    Total Matricole: <strong>{{ matricoleLoaded }}</strong>
                                                </h4>
                                            </div>
                                            <div class="col-sm-6">
                                                <h4>
                                                    Matricole Selectate: <strong>{{ selectedRowIds.length }}</strong>
                                                </h4>
                                            </div>
                                        </div>
                                        <form [formGroup]="form" (ngSubmit)="previewMatricoleForConfirmation()">
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <mat-form-field class="w-100">
                                                        <mat-label>Operație</mat-label>
                                                        <mat-select formControlName="operatie">
                                                            <mat-option *ngFor="let operatie of matricoleOperatii" [value]="operatie.value">
                                                                {{ operatie.key }}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                            *ngIf="form.get('operatie')?.touched && form.get('operatie')?.invalid">
                                                            Câmp obligatoriu
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>

                                                <div class="col-sm-4">
                                                    <mat-form-field class="w-100">
                                                        <mat-label>Scop CF</mat-label>
                                                        <mat-select formControlName="scopcf">
                                                            <mat-option *ngFor="let scop of matricoleScopuriCF" [value]="scop.value">
                                                                {{ scop.key }}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                            *ngIf="form.get('scopcf')?.touched && form.get('scopcf')?.invalid">
                                                            Câmp obligatoriu
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                                
                                                <div class="col-sm-4">
                                                    <mat-form-field class="w-100">
                                                        <mat-label>Fără Listă Patrimoniu</mat-label>
                                                        <mat-select formControlName="fara_patrimoniu">
                                                            <mat-option *ngFor="let option of matricoleYesNo" [value]="option.value">
                                                                {{ option.key }}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            
                                            
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <mat-form-field class="w-100">
                                                        <mat-label>Specificații</mat-label>
                                                        <textarea matInput formControlName="specificatii"></textarea>
                                                        <mat-error
                                                            *ngIf="form.get('specificatii')?.touched && form.get('specificatii')?.invalid">
                                                            Câmp obligatoriu
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>

                                                <div class="col-sm-4">
                                                    <mat-form-field class="w-100">
                                                        <mat-label>Alte Mențiuni</mat-label>
                                                        <textarea matInput formControlName="alte_mentiuni"></textarea>
                                                    </mat-form-field>
                                                </div>

                                                <div class="col-sm-4 mt-3">
                                                    <button type="submit" class="btn btn-light action-button col-sm-4 w-100 d-flex align-items-center justify-content-center"
                                                        [disabled]="form.invalid">
                                                        Generează CF
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>